import {META_DEFAULT_BASE_URL} from '../constants';

/**
 * The single source of truth for "this route is English, whatever `[lang]` says".
 *
 * `/communities` renders English copy for every locale (the communities themselves are
 * English-only), so the i18n provider, the `lang`/`dir` subtree markers, and the route
 * metadata all have to agree on one language. They read it from here rather than each
 * hardcoding `'en'`, so that un-forcing English later is a single-file change.
 *
 * Deliberately free of `server-only` and of any filesystem import, unlike its sibling
 * `english-locale.ts`: `english-i18n-provider.tsx` is a client component and needs
 * these same values, so they cannot live in a server-only module.
 */
export const ENGLISH_LANG = 'en';
export const ENGLISH_LOCALE = 'en_US';

/**
 * Where crawlers should be pointed for this route, from every locale prefix.
 *
 * `/tr/communities/`, `/de/communities/`, … all serve the same English body, which
 * without a canonical is a few dozen near-duplicate URLs competing with each other.
 * One canonical collapses them; deliberately no `hreflang` alternates, because
 * advertising per-language variants of a page that has none is the wrong signal.
 *
 * ASSUMPTION TO VERIFY: that English lives at `/communities/` with no locale prefix,
 * matching the rest of udemy.com. If the edge routing serves English at
 * `/en/communities/` instead, this constant is the only thing that changes.
 */
export const COMMUNITIES_CANONICAL_URL = `${META_DEFAULT_BASE_URL}/communities/`;
